export const APPROVE_PAYMENT = 'approvePayment'
export const APPROVE_REFUND = 'approveRefund'
export const REJECT_PAYMENT = 'rejectPayment'
export const REJECT_REFUND = 'rejectRefund'
